// src/components/Toast.jsx
import { createContext, useContext, useState, useCallback } from "react";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "success") => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t.slice(-3), { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3500);
  }, []);

  return (
    <ToastCtx.Provider value={showToast}>
      {children}
      <div style={{
        position: "fixed", bottom: 24, right: 24,
        display: "flex", flexDirection: "column", gap: 8,
        zIndex: 9999, pointerEvents: "none",
      }}>
        {toasts.map(toast => (
          <div key={toast.id} style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "10px 16px",
            borderRadius: 10,
            fontFamily: "var(--font, system-ui)",
            fontSize: 13,
            fontWeight: 500,
            color: "#fff",
            pointerEvents: "auto",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.18), inset 0 1.5px 0 rgba(255,255,255,0.18)",
            animation: "toastIn .22s ease",
            ...(toast.type === "success" ? {
              background: "rgba(5,150,105,0.92)",
              border: "1px solid rgba(255,255,255,0.22)",
            } : toast.type === "error" ? {
              background: "rgba(185,28,28,0.92)",
              border: "1px solid rgba(255,255,255,0.18)",
            } : {
              background: "rgba(30,64,175,0.92)",
              border: "1px solid rgba(255,255,255,0.18)",
            }),
          }}>
            <span style={{ fontSize: 16 }}>
              {toast.type === "success" ? "✓" : toast.type === "error" ? "✕" : "ℹ"}
            </span>
            {toast.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
